import { VpRadioGroupChip, VpRadioGroupChipItem, VpRadioGroupChipItemLabel } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { trackEvent } from '@/src/analytics/amplitude'

export type MyTeamTab = 'vendors' | 'diagnoses'

export interface MyTeamTabsProps {
  value: MyTeamTab
  onChange: (value: MyTeamTab) => void
}

const MyTeamTabs = ({ value, onChange }: MyTeamTabsProps) => {
  const { t } = useTranslation('common')
  const handleTabChange = (tab: MyTeamTab) => {
    if (tab === 'diagnoses') trackEvent('MY_TEAM_ALL_TAB_CLICK')
    onChange(tab)
  }
  return (
    <div>
      <VpRadioGroupChip
        className="w-full flex gap-2"
        value={value}
        onChange={(e) => handleTabChange(e.target.value as MyTeamTab)}
      >
        <VpRadioGroupChipItem
          data-testid="my-team-vendor-tab"
          className="flex-1 min-w-0 justify-center"
          value={'vendors'}
          labelSlot={<VpRadioGroupChipItemLabel>{t('global.vendors')}</VpRadioGroupChipItemLabel>}
        />
        <VpRadioGroupChipItem
          data-testid="my-team-all-tab"
          className="flex-1 min-w-0 justify-center"
          value={'diagnoses'}
          labelSlot={<VpRadioGroupChipItemLabel>{t('global.all')}</VpRadioGroupChipItemLabel>}
        />
      </VpRadioGroupChip>
    </div>
  )
}

export default MyTeamTabs
